/**
 * Constant Key 정보
 */

// 헤더바 높이
export const APP_BAR_HEIGHT = 44
